/*
 * @Author: mayanxia
 * @Date: 2023-03-21 15:04:59
 * @Last Modified by: mayanxia
 * @Last Modified time: 2023-07-26 11:14:46
 */

<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('设备编号')">
              <j-input :placeholder="$t('输入设备编号模糊查询')" v-model="queryParam.deviceId"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="$t('设备名称')">
              <j-input :placeholder="$t('输入设备名称模糊查询')" v-model="queryParam.deviceName"></j-input>
            </a-form-item>
          </a-col>
            <!-- <a-col :span="8">
                  <a-form-model-item label="上报时间">
                    <a-range-picker
                      v-model="date"
                      :placeholder="['查询起始时间', '查询结束时间']"
                      format="YYYY-MM-DD"
                      @change="onDateRangeChange"
                    />
                  </a-form-model-item>
                </a-col> -->
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              <a @click="handleToggleSearch" style="margin-left: 8px">
                {{ toggleSearchStatus ? $t('收起') : $t('展开') }}
                <a-icon :type="toggleSearchStatus ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="handleAdd">{{ $t('新增') }}</a-button>
      <a-button type="primary" icon="download" @click="handleExportXls($t('实时数据'))" style="margin-left: 8px">{{ $t('导出') }}</a-button>
      <a-button icon="download" @click="downloadTemplate" style="margin-left: 8px">{{ $t('下载导入模板') }}</a-button>
      <a-upload
        name="file"
        :multiple="false"
        accept=".xls,.xlsx"
        :headers="tokenHeader"
        :action="importExcelUrl"
        :showUploadList="false"
        @change="handleImport"
        style="display:inline-block;margin-left: 8px">
        <a-button icon="upload">{{ $t('批量导入') }}</a-button>
      </a-upload>
    </div>

    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="meterId"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">
        <span slot="action" class="action" slot-scope="text, record">
<!--          <a @click="handleHistory(record)">历史数据</a>-->
          <a @click="handleDetail(record)">{{ $t('详情') }}</a>
          <a @click="handleInput(record)">{{ $t('录入') }}</a>
          <a @click="handleEditStandard(record)">{{ $t('编辑标准') }}</a>
        </span>
      </a-table>
    </div>
    <part-water-quality-last-record-modal ref="modalForm" @ok="modalFormOk"></part-water-quality-last-record-modal>
    <PartWaterQualityLastRecordListEchartsModel ref="historyRef" @ok="modalFormOk"></PartWaterQualityLastRecordListEchartsModel>
    <WaterQualityStandardsModal ref="stanrdsRef" @ok="modalFormOk"></WaterQualityStandardsModal>
    <WaterQualityManualAddModal ref="manualAddRef" @ok="modalFormOk"></WaterQualityManualAddModal>
  </a-card>
</template>

<script>

  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import JInput from '@/components/jeecg/JInput'
  import { getAction, downFile } from '@/api/manage'
  import { isUndefined,isNull,isUndefinedAndNull } from'@/utils/validate'
  import PartWaterQualityLastRecordModal from './modules/PartWaterQualityLastRecordModal'
  import PartWaterQualityLastRecordListEchartsModel from './modules/PartWaterQualityLastRecordListEchartsModel'
  import WaterQualityStandardsModal from './modules/WaterQualityStandardsModal'
  import WaterQualityManualAddModal from './modules/WaterQualityManualAddModal'

  function judgeStandard(min,max,num) {
    if(isNull(min)&&isNull(max)) {
      return true
    }else {
      if(!isNull(min)&&Number(min)>Number(num)) {
        return false
      }else if(!isNull(max)&&Number(max)<Number(num)) {
        return false
      }
    }
    return true
  }

  export default {
    name: 'PartWaterQualityLastRecordList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      JInput,
        PartWaterQualityLastRecordModal,
        PartWaterQualityLastRecordListEchartsModel,
        WaterQualityStandardsModal,
        WaterQualityManualAddModal
    },
    data () {
      return {
        description: '水质监测实时数据管理页面',
        url: {
          list: "/jeecg-charge/part/partWaterQualityLastRecord/list",
          exportXlsUrl: "/jeecg-charge/part/partWaterQualityLastRecord/exportXls",
          // 水质标准表(上下限),按 deviceId 挂载到每条记录的 __std,供列红绿比对
          metricsList: "/jeecg-charge/wq/meterDeviceMetrics/list",
          importExcelUrl: "jeecg-charge/part/partWaterQualityLastRecord/importExcel",
          importTemplateUrl: "/jeecg-charge/part/partWaterQualityLastRecord/importTemplate",
        },
        dictOptions:{},
        /* 排序参数 */
        isorter:{
          column: 'createTime',
          order: 'desc',
        },
        dateType: 2
      }
    },
    created() {
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：表头使用 computed 以响应语言切换
      columns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'meterId'
          },{
            title: this.$t('设备名称'),
            align:"center",
            dataIndex: 'deviceName'
          },
          {
            title: this.$t('安装位置'),
            align:"center",
            dataIndex: 'deviceLocation'
          },
          {
            title: this.$t('上传时间'),
            align:"center",
            dataIndex: 'sysTime'
          },
          {
            title: this.$t('温度值(℃)'),
            align:"center",
            dataIndex: 'w01010-Rtd',
            customRender: this.stdCell('temperatureTop', 'temperatureBottom')
          },
          {
            title: this.$t('PH值'),
            align:"center",
            dataIndex: 'w01001-Rtd',
            customRender: this.stdCell('phTop', 'phBottom')
          },
          {
            title: this.$t('色度'),
            align:"center",
            dataIndex: 'w01002-Rtd',
            customRender: this.stdCell('chromaTop', 'chromaBottom')
          },
          {
            title: this.$t('浑浊度(NTU)'),
            align:"center",
            dataIndex: 'w01003-Rtd',
            customRender: this.stdCell('ntuTop', 'ntuBottom')
          },
          {
            title: this.$t('溶解性总固体(mg/L)'),
            align:"center",
            dataIndex: 'w01006-Rtd',
            customRender: this.stdCell('dissolvedSolidsTop', 'dissolvedSolidsBottom')
          },
          {
            title: this.$t('硬度(mg/L)'),
            align:"center",
            dataIndex: 'w10000-Rtd',
            customRender: this.stdCell('hardnessTop', 'hardnessBottom')
          },
          {
            title: this.$t('ORP(mv)'),
            align:"center",
            dataIndex: 'w10001-Rtd',
            customRender: this.stdCell('orpTop', 'orpBottom')
          },
          {
            title: this.$t('氯化物(mg/L)'),
            align:"center",
            dataIndex: 'w21022-Rtd',
            customRender: this.stdCell('chlorideTop', 'chlorideBottom')
          },
          {
            title: this.$t('余氯(mg/L)'),
            align:"center",
            dataIndex: 'w21024-Rtd',
            customRender: this.stdCell('residualChlorineTop', 'residualChlorineBottm')
          },
          {
            title: this.$t('硫酸盐(mg/L)'),
            align:"center",
            dataIndex: 'w21038-Rtd',
            customRender: this.stdCell('sulfateTop', 'sulfateBottm')
          },
          {
            title: this.$t('电导率(μS/cm)'),
            align:"center",
            dataIndex: 'w01014-Rtd',
            customRender: this.stdCell('electricalConductivityTop', 'electricalConductivityBottm')
          },
          {
            title: this.$t('操作'),
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }
        ]
      },
    },
    methods: {
      initDictConfig(){
      },
      renderTile(down,up) {
        let title="";
        if(!isUndefinedAndNull(down)) {
          title+= this.$t('最小值:')+down
        }
        if(!isUndefinedAndNull(up)) {
          if(title == '') {
            title+= this.$t('最大值:')+up
          }else{
            title+=','+this.$t('最大值:')+up
          }

        }
        return title;
      },
      /**
       * 生成指标列的 customRender。
       * 标准来源:r.__std(由 loadData 从 meter_device_metrics 表按 deviceId 挂载),字段为扁平的 Top/Bottom。
       * 返回 antd 单元格配置对象 { children, attrs, style },不依赖 JSX/h,避免在提取出的函数中 h 未定义。
       * @param topField    标准表上限字段名,如 'temperatureTop'
       * @param bottomField 标准表下限字段名,如 'temperatureBottom'
       */
      stdCell(topField, bottomField) {
        return (t, r, index) => {
          if(isUndefined(t)) {
            return '--'
          }
          let std = r && r.__std ? r.__std : null
          if(!std) {
            return t
          }
          let down = std[bottomField]
          let up = std[topField]
          let title = this.renderTile(down, up)
          if(title == "") {
            // 未设置上下限值
            return t;
          }
          // 达标绿色,超标红色;鼠标悬停显示上下限
          let color = judgeStandard(down, up, t) ? 'green' : 'red'
          return { children: t, attrs: { title: title }, style: { color: color } }
        }
      },
      loadData(arg) {
        if(!this.url.list){
          this.$message.error(this.$t("请设置url.list属性!"))
          return
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            let dataSource = res.result.records || [];
            this.ipagination.total = res.result.total;
            // 先展示数据(标准未挂载时各列按原值显示),再异步挂载标准做红绿比对
            this.dataSource = dataSource;
            this.loadMetrics(dataSource);
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      /**
       * 拉取水质标准表(meter_device_metrics),按 deviceId 挂到每条记录的 __std。
       * 标准接口失败不应影响列表展示,故静默 catch。
       */
      loadMetrics(dataSource) {
        if(!dataSource || dataSource.length === 0) {
          return
        }
        getAction(this.url.metricsList, { pageNo: 1, pageSize: 1000 }).then((res) => {
          if(!res.success) {
            return
          }
          let records = (res.result && res.result.records) || []
          let map = {}
          records.forEach(m => {
            if(m.deviceId) {
              map[m.deviceId] = m
            }
          })
          // 挂载标准并触发表格刷新
          dataSource.forEach(row => {
            this.$set(row, '__std', map[row.meterId] || null)
          })
          this.dataSource = [...dataSource]
        }).catch(() => {})
      },
      handleHistory(row){
        this.$nextTick(()=>{
          this.$refs.historyRef.init(row);
        })
      },
      handleEditStandard(record){
        this.$nextTick(()=>{
          this.$refs.stanrdsRef.init(record);
        });
      },
      handleAdd(){
        this.$refs.manualAddRef.open({});
      },
      handleInput(record){
        this.$refs.manualAddRef.open({
          meterId: record.meterId,
          deviceName: record.deviceName,
          deviceLocation: record.deviceLocation
        });
      },
      // 下载批量导入Excel模板(后端动态导出空表头)
      downloadTemplate(){
        downFile(this.url.importTemplateUrl, {}).then((data) => {
          if (!data) {
            this.$message.warning(this.$t("模板下载失败"))
            return
          }
          let url = window.URL.createObjectURL(new Blob([data], { type: 'application/vnd.ms-excel' }))
          let link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', this.$t('水质监测数据导入模板') + '.xls')
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
        })
      },
      // 批量导入回调
      handleImport(info){
        if (info.file.status === 'done') {
          let res = info.file.response
          if (res && res.success) {
            let result = res.result || {}
            let successCount = result.successCount || 0
            let failList = result.failList || []
            if (failList.length > 0) {
              // 展示失败明细
              const h = this.$createElement
              let failEles = failList.map(f =>
                h('p', { style: 'margin:0' }, this.$t('第{row}行 设备[{device}]: {message}', { row: f.rowNum, device: f.deviceId || '', message: f.message }))
              )
              this.$warning({
                title: this.$t('导入完成:成功 {success} 条,失败 {fail} 条', { success: successCount, fail: failList.length }),
                content: h('div', { style: 'max-height:300px;overflow:auto' }, failEles)
              })
            } else {
              this.$message.success(this.$t('导入成功 {count} 条', { count: successCount }))
            }
            this.loadData(1)
          } else {
            this.$message.error((res && res.message) || this.$t('导入失败'))
          }
        } else if (info.file.status === 'error') {
          this.$message.error(this.$t('文件上传失败: {name}', { name: info.file.name }))
        }
      }
    }
  }
</script>
